module.exports = __webpack_public_path__ + "img/icon51.2178659a.png";